<ng-container *ngIf="!taskCreationMode && !showAssignedUsersPanel">
    <div class="task-detail-header">
        <gsp-button [type]="ButtonType.Icon" [iconClass]="'icon-arrow-back-black i24'" (action)="back()"></gsp-button>
        <h2 class="title">{{ 'TC.Common.TaskDetails' | translate }}</h2>
        <div *ngIf="!loading" class="task-panel-menu-bar">
            <gsp-button
                [type]="ButtonType.Icon"
                [iconClass]="'icon_line_trash_red_32 i24'"
                title="{{ 'TC.Common.Delete' | translate }}"
                (action)="deleteTaskConfirmation = true"
            ></gsp-button>
            <gsp-button
                *ngIf="task.status !== TaskStatus.COMPLETE"
                [type]="ButtonType.Icon"
                [iconClass]="'icon_line_task_edit_32 i24'"
                title="{{ 'TC.Common.Edit' | translate }}"
                [disabled]="taskFeaturesLoading"
                (action)="editTask()"
            ></gsp-button>
            <gsp-button
                [class]="task.isClosed ? 'reopen-button' : 'complete-button'"
                [type]="task.isClosed ? ButtonType.TextIcon : ButtonType.Icon"
                [iconClass]="task.isClosed ? 'icon_line_refresh_32 i24' : 'icon_line_check_24 i24'"
                title="{{ task.isClosed ? null : ('TodosTasks.CompleteTask' | translate) }}"
                text=" {{
                    task.isClosed ? ('TodosTasks.ReopenTask' | translate) : ('TodosTasks.CompleteTask' | translate)
                }}"
                (action)="closeOrReopenTaskConfirmation = true"
            ></gsp-button>
        </div>
    </div>

    <div class="no-hover" *ngIf="loading">
        <loading class="loading-align-center"></loading>
    </div>
    <div *ngIf="!loading" class="task-content">
        <div class="error-notification" *ngIf="exceedsLimit">
            <p>{{ 'MapViewer_ToDos_ExceedsLimit' | translate: { maxTaskFeatureCount: maxTaskFeatureCount } }}</p>
        </div>

        <div class="title text-overflow">{{ task.title }}</div>
        <custom-scroll class="task-description-scroll input-group">
            <div class="task-description-text">
                {{ task.description }}
            </div>
        </custom-scroll>

        <section class="collected-forms">
            <div class="collected-forms-new-forms">
                <span>{{ 'TC.Common.NewFormsCollected' | translate }}</span>
                <div class="collected-forms-data">
                    <i class="icon_solid_clipboard_24 mixin-icon-24"></i>{{ task.newFeatures }}
                </div>
            </div>
            <div class="collected-forms-total-forms">
                <span>{{ 'TC.Common.TotalFormsCollected' | translate }}</span>
                <div class="collected-forms-data">
                    <i class="icon_solid_clipboard_24 mixin-icon-24"></i>{{ task.totalCollectedFeatures }}
                </div>
            </div>
        </section>
        <section class="title-with-text-action">
            <div class="title">
                {{ 'TC.Common.AssignedUsers' | translate }}
            </div>
            <gsp-button
                [type]="ButtonType.TextIcon"
                text="{{ 'TC.Common.ViewAll' | translate }}"
                class="button-text-action"
                [iconClass]="'text-button-no-icon'"
                (action)="toggleAssignedUsersPanel()"
                [class.disabled]="!task.assignees.length"
            ></gsp-button>
        </section>
        <section class="assigned-users">
            <div class="assigned-users-count">
                <span>{{ 'TC.Common.AssignedUsers' | translate }}</span>
                <div class="collected-forms-data"><i class="icon-people-group i24"></i>{{ task.assignees.length }}</div>
            </div>
            <div class="assigned-users-total-completed">
                <span>{{ 'TC.Todos.TotalCompleted' | translate }}</span>
                <div class="collected-forms-data">
                    <i class="icon-tick-in-circle-green i24"></i>{{ task.completedUserIds.length }}
                </div>
            </div>
        </section>

        <div class="title-with-text-action">
            <div class="title">{{ 'TC.Common.Forms' | translate }}</div>
            <gsp-button
                [type]="ButtonType.TextIcon"
                text="{{ 'selectAll' | translate }}"
                class="button-text-action"
                [iconClass]="'text-button-no-icon'"
                [class.disabled]="!taskPanelLayers.length"
                (action)="selectAllForms()"
            ></gsp-button>
        </div>
        <custom-scroll class="task-forms-data">
            <loading *ngIf="taskFeaturesLoading"></loading>
            <ng-containter *ngIf="!taskFeaturesLoading">
                <div *ngFor="let taskPanelLayer of taskPanelLayers">
                    <li *ngIf="taskPanelLayer.layer">
                        <geom-icon
                            path="sym_32-geom-"
                            [color]="taskPanelLayer.layerColor"
                            [geoType]="getTemplateGeometryType(taskPanelLayer.templateSeriesId)"
                        ></geom-icon>
                        <div class="layer-title" title="{{ getLayerName(taskPanelLayer.layer) }}">
                            {{ getLayerName(taskPanelLayer.layer) }}
                        </div>
                        <div class="feature-count">
                            {{ getTaskFormsByLayer(taskPanelLayer.layer).length }}
                            {{ 'TC.Common.Forms' | translate | lowercase }}
                        </div>
                    </li>
                </div>
            </ng-containter>
        </custom-scroll>
    </div>
    <gsp-confirmation-popup
        *ngIf="closeOrReopenTaskConfirmation"
        [heading]="task.isClosed ? 'TodosTasks.ReopenTask.Title' : 'TodosTasks.CompleteTask.Title'"
        (cancel)="closeOrReopenTaskConfirmation = false"
        [confirmAction]="closeOrReopenTaskAction"
        [confirmationButtonText]="task.isClosed ? 'TodosTasks.ReopenTask' : 'TodosTasks.CompleteTask'"
        [confirmationButtonType]="ButtonType.Primary"
        [message]="
            task.isClosed
                ? ('TodosTasks.ReopenTask.Confirmation' | translate: { taskName: task.title })
                : ('TodosTasks.CompleteTask.Confirmation' | translate: { taskName: task.title })
        "
        class="task-complete-confirmation"
    >
    </gsp-confirmation-popup>
    <gsp-confirmation-popup
        *ngIf="deleteTaskConfirmation"
        [heading]="'deleteTask'"
        (cancel)="deleteTaskConfirmation = false"
        [confirmAction]="deleteAction"
        [confirmationButtonText]="'deleteTask'"
        [message]="'Todos.DeleteTodoQuestion' | translate: { taskName: task.title }"
        class="task-delete-confirmation"
    >
    </gsp-confirmation-popup>
</ng-container>

<ng-container *ngIf="taskCreationMode">
    <task-creation-panel [task]="task"></task-creation-panel>
</ng-container>

<ng-container *ngIf="showAssignedUsersPanel">
    <task-assigned-users
        [task]="task"
        [modifyPermission]="modifyPermission"
        (closeAssignedUsersPanel)="toggleAssignedUsersPanel()"
    ></task-assigned-users>
</ng-container>
